define('lq/events/actions/login',[
    'jquery',
    'lq',
    'lq/events/actions/eventAction'
], function ($, lq, EventAction) {
    'use strict';

    function Login(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        return this;
    }

    EventAction.extend(Login, EventAction);

    Login.typeName = 'Login';

    Login.prototype.getBatchType = function () {
        return EventAction.DO_NOT_BATCH;
    };

    Login.prototype.mfaId = [];
    Login.prototype.mfaPollingTimer = [];

    var loginCallback = function (self, result, returnUrl, continuation, showBody) {
        if (result.status === 'Success') {
            returnUrl = returnUrl || lq.getTenantUrl('');

            if (self.eventIsEnabled('userLoggedIn'))
                self.piping.dispatcher.refreshCsrfToken(function () {
                    self.triggerEvent('userLoggedIn', continuation, returnUrl);
                });
            else
                window.location = returnUrl;
        }
        else {
            if (showBody) $('body').show();

            self.mfaId[self.eventData.command] = result.mfaId;

            if (result.status === 'LoginFromLocalStorageFailed')
                return;
            else if (result.status === 'InvalidCaptcha')
                self.handleError('invalidCaptcha', 'The captcha is incorrect.', continuation);
            else if (result.status === 'InvalidCredentials')
                self.handleError('invalidCredentials', 'The username or password provided is incorrect.', continuation);
            else if (result.status === 'UserLoginNotAllowed')
                self.handleError('userLoginNotAllowed', 'The user is not allowed to log in.', continuation, result.userId);
            else if (result.status === 'AccountLocked')
                self.handleError('accountLocked', 'Your account has been locked out because of too many invalid login attempts.', continuation);
            else if (result.status === 'MfaChallenged') {
                self.startPollingMfaStatus(result.mfaId);
                self.handleError('mfaChallenged', 'MFA is necessary.', continuation);
            }
            else if (result.status === 'MfaExpired') {
                self.stopPollingMfaStatus();
                self.handleError('mfaExpired', 'MFA is expired.', continuation);
            }
            else if (result.status === 'MfaCodeInvalid')
                self.handleError('mfaCodeInvalid', 'The MFA code is incorrect.', continuation);
            else
                alert('Unable to login.');
        }
    }

    Login.prototype.getUsername = function () {
        return this.piping.dropFactory
            .findDropByViewModelKey(this.eventData.usernameField)
            .getValue();
    };

    Login.prototype.getPassword = function () {
        return this.piping.dropFactory
            .findDropByViewModelKey(this.eventData.passwordField)
            .getValue();
    };

    Login.prototype.getMfaCode = function () {
        if (!this.eventData.mfaCodeField) return null;

        return this.piping.dropFactory
            .findDropByViewModelKey(this.eventData.mfaCodeField)
            .getValue();
    };

    Login.prototype.getCaptcha = function () {
        if (!this.eventData.captchaField) return null;

        var captchaDrop = this.piping.dropFactory
            .findDropByName(this.eventData.captchaField);

        if (!captchaDrop.data.captchaInputField) return null;

        return this.piping.dropFactory
            .findDropByName(captchaDrop.data.captchaInputField)
            .getValue();
    };

    Login.prototype.execute = function (continuation) {
        this.executeLogin(continuation, null);
    }

    Login.prototype.executeLogin = function (continuation, mfaConfirmed) {
        var username = this.getUsername();
        var password = this.getPassword();
        var captcha = this.getCaptcha();
        var mfaCode = this.getMfaCode();
        var returnUrl = this.piping.queryString.getValueOf('ReturnUrl');

        //deliberately not calling continuation(), because it makes no sense to continue event execution after a login/redirect
        var self = this;
        this.piping.dispatcher.dispatch(
            'LicquidAction/LoginCommand', {
            actionId: this.piping.actionId,
            commandId: this.eventData.command,
            captcha: captcha,
            appId: this.piping.queryString.getValueOf('AppId'),
            parameters: {
                username: username,
                password: password,
                mfaId: self.mfaId[self.eventData.command],
                mfaCode: mfaCode,
                mfaConfirmed: mfaConfirmed
            }
        }, function (result) {
            loginCallback(self, result, returnUrl, continuation, false);
        });
    };

    Login.prototype.handleError = function (eventName, defaultMessage, continuation, eventArg) {
        if (this.eventIsEnabled(eventName)) {
            this.triggerEvent(eventName, continuation, eventArg);
        } else {
            alert(defaultMessage);
            continuation();
        }
    };

    Login.prototype.stopPollingMfaStatus = function () {
        var self = this;

        const timer = self.mfaPollingTimer[self.eventData.command];
        if (timer) {
            clearTimeout(timer);
            self.mfaPollingTimer[self.eventData.command] = undefined;
        }
    }

    Login.prototype.startPollingMfaStatus = function (mfaId) {
        var self = this;

        var pollMfaStatus = function () {
            self.piping.dispatcher.backgroundDispatch(
                'Mfa/Status',
                {
                    mfaId: mfaId
                },
                function (result) {
                    if (!self.mfaPollingTimer[self.eventData.command]) return;

                    if (result.expired) {
                        self.stopPollingMfaStatus();
                        self.handleError('mfaExpired', 'MFA is expired.');
                        return;
                    }

                    if (result.confirmed) {
                        self.stopPollingMfaStatus();
                        self.executeLogin(null, true);
                        return;
                    }

                    self.startPollingMfaStatus(mfaId);
                });
        };

        self.stopPollingMfaStatus();
        self.mfaPollingTimer[self.eventData.command] = setTimeout(pollMfaStatus, 1000);
    }

    return Login;
});
